__turbopack_context__.v({
  "footer": "footer-module-scss-module__PbV9kq__footer",
  "footer-content": "footer-module-scss-module__PbV9kq__footer-content",
  "footer-links-content": "footer-module-scss-module__PbV9kq__footer-links-content",
  "footer-logo": "footer-module-scss-module__PbV9kq__footer-logo",
  "footer-logo-social": "footer-module-scss-module__PbV9kq__footer-logo-social",
});
